<template>
  <button
    class="finish-button"
    type="button"
    @click="finishButtonHandler"
  >
    <span class="finish-button__text">{{ finishButtonTitle }}</span>
  </button>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useConfigStore, useLineItemStore } from '../../stores';
import pinia from '../../core/pinia';

import { E_FINISH_BUTTON_EVENT } from '../../types/components-events.enums';
import type { TFinishButtonEventResponse } from '../../types/event-response.types';


const emit = defineEmits<{
  (event: E_FINISH_BUTTON_EVENT.FINISH, payload: TFinishButtonEventResponse[E_FINISH_BUTTON_EVENT.FINISH]): void;
}>();

const configStore = useConfigStore(pinia);
const lineItemStore = useLineItemStore(pinia);

const finishButtonTitle = computed(() => configStore.getButtonTitles.finish);
const lineItem = computed(() => lineItemStore.getLineItem);

async function finishButtonHandler() {
  const variantDesignResponse = await configStore.fetchVariantDesign();
  const productVariantId = variantDesignResponse.items[0].productVariantId;
  lineItemStore.updateLineItem({
    productVariantId: productVariantId,
  });

  emit(E_FINISH_BUTTON_EVENT.FINISH, lineItem.value);
}
</script>

<style scoped lang="scss">
.finish-button {
  background-color: $brand-color;
  padding: 12px 24px;
  border: none;
  cursor: pointer;
  width: 100%;

  &__text {
    color: #FFFFFF;
    font-family: 'Bebas Neue', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0%;
    text-align: center;
    vertical-align: middle;
    text-transform: uppercase;
  }
}
</style>